"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userServicesParamsDefaults = exports.contentMeetingParamsDefaults = void 0;
exports.contentMeetingParamsDefaults = {
  fee_meeting_finalize_calculations__finishedAgo: null,
  credits_meeting_finalize_calculations__startedAgo: null,
  auto_cancel__scheduledAgo: 10,
  alert_review__delays: '0',
  remind_review_delays: '0',
  alert_shutdown__beforeFinish: '0',
  default_immediate_meeting_duration: 60,
  minimum_immediate_meeting_duration: 30,
  minimum_specified_meeting_duration: 30,
  cancel_reservation_delay: 0,
  remind_meeting_reservation_delays: '0',
  next_user_service_delay: 168,
  remind_upcoming_meeting_delays: '0',
  minimal_meeting_percent_to_presence: 0.5,
  meeting_recurring_payment__delays: null,
  payment_confirm_delay__finishedAgo: 0,
  meeting_cancel_with_penalty__beforeStart: 24,
  meeting_cancel_allowed__beforeStart: 1,
  meeting_leave_with_penalty__beforeStart: 24,
  meeting_leave_allowed__beforeStart: 1,
  group_contract_acceptable_late_time: 10
};
exports.userServicesParamsDefaults = {
  cancel_signup_order_delay: 15,
  suspend_prolong_order_delay: 60,
  break_suspended_contract_delay: 24 * 60,
  remind_pending_order_delays: '1,5'
};
